/* global $, Shopify, meta */
(function () {
  const AUTO_TRACKING_SCRIPT_FLAG = '__OGL_AUTO_TRACKING_SCRIPT_LOADED__';
  if (window[AUTO_TRACKING_SCRIPT_FLAG]) {
    console.warn(
      'OGL auto-tracking script already loaded, skip duplicate init'
    );
    return;
  }
  window[AUTO_TRACKING_SCRIPT_FLAG] = true;

  (function () {
    try {
      // 配置默认埋点
      const trackingConfig = [
        // nav
        {
          selector: {
            container: '#t4s-nav-ul',
            item: ['.t4s-menu-item']
          },
          section_name: 'nav'
        },
        // nav icons
        {
          selector: {
            container: '.t4s-site-nav__icons',
            item: ['.t4s-site-nav__icon']
          },
          section_name: 'nav-icon'
        },
        // filter
        {
          selector: {
            container: '.t4s-btn-filter-wrapper',
            item: ['']
          },
          section_name: 'filter'
        },
        // filter sort by
        {
          selector: {
            container: '.t4s-dropdown__sortby',
            item: ['']
          },
          section_name: 'filter-sortby'
        },
        // logo
        {
          selector: {
            container: '.t4s-header__logo',
            item: ['']
          },
          section_name: 'logo'
        },
        // shipping
        {
          selector: {
            container: '.t4s-shipping-list',
            item: ['.t4s-shipping']
          },
          section_name: 'shipping'
        },
        // cookie 弹窗
        {
          selector: {
            container: '.shopify-pc__banner__btns',
            item: ['button']
          },
          section_name: 'cookie-popup'
        },
        // footer
        {
          selector: {
            container: '.t4s-footer-content',
            item: ['li', '.t4s-col-item']
          },
          section_name: 'footer'
        },
        // footer-heading
        {
          selector: {
            container: '.t4s-footer-heading',
            item: ['']
          },
          section_name: 'footer-heading'
        },
        // breadcrumb
        {
          selector: {
            container: '.t4s-pr-breadcrumb',
            item: ['a']
          },
          section_name: 'breadcrumb'
        },
        // custom liquid
        {
          selector: {
            container: '[class*="__custom_liquid_"]', // 使用 :visible:eq(n) 来选择
            item: ['video', '.fabric-column', 'a', 'button'] // 每一项都可能会有很多个，注意使用 :eq(n) 来选择
          },
          section_name: 'custom-liquid'
        },
        // custom html
        {
          selector: {
            container: '[class*="__custom_html_"]',
            item: ['video', 'a', 'button']
          },
          section_name: 'custom-html'
        },
        // background video
        {
          selector: {
            container: '[class*="__background_video_"]',
            item: ['video']
          },
          section_name: 'background-video'
        },
        // collections list
        {
          selector: {
            container: '[class*="__collections_list_"]',
            item: ['.t4s-cat-content']
          },
          section_name: 'collections-list'
        },
        // banner
        {
          selector: {
            container: '.t4s-banner-holder',
            item: ['.t4s-banner-item']
          },
          section_name: 'banner'
        },
        // flickityt4s-wrap 首页面料入口等
        {
          selector: {
            container: '.flickityt4s-wrap',
            item: ['.t4s-collection-item']
          },
          section_name: 'flickityt4s-wrap-collection-item'
        },
        // 德国站语言切换
        {
          selector: {
            container: '.hq-current-language',
            item: ['']
          },
          section_name: 'language-selector'
        },
        // 详情页 fabric
        {
          selector: {
            container: '.mibao_fabric_list',
            item: ['> a', '> span']
          },
          section_name: 'fabric'
        },
        // 详情页 style
        {
          selector: {
            container: '.t4s-swatch__list',
            item: ['[data-swatch-item]']
          },
          section_name: 'style'
        },
        // shop by category
        {
          selector: {
            container: '[class*="_template--"].shop_by_category',
            item: ['.t4s-collection-item']
          },
          section_name: 'shop-by-category'
        },
        // products
        {
          selector: {
            container: '.t4s-products',
            item: ['.t4s-product']
          },
          section_name: 'products'
        },
        // women_list
        {
          selector: {
            container: '.women_list',
            item: ['.t4s-collection-item']
          },
          section_name: 'women-list'
        },
        // influencers_in_ogl
        {
          selector: {
            container: '.influencers_in_ogl',
            item: ['[data-goto--item]']
          },
          section_name: 'influencers-in-ogl'
        },
        // related_searches
        {
          selector: {
            container: '.related_searches',
            item: ['.t4s-feature-columns__content']
          },
          section_name: 'related-searches'
        },
        // site_women_list
        {
          selector: {
            container: '.site_women_list',
            item: ['.t4s-collection-item']
          },
          section_name: 'site-women-list'
        },
        // t4s-announcement-bar
        {
          selector: {
            container: '.t4s-announcement-bar',
            item: ['']
          },
          section_name: 'announcement-bar'
        },
        // data-currency-wrap
        {
          selector: {
            container: '[data-currency-wrap]',
            item: ['']
          },
          section_name: 'currency-wrap'
        },

        // product页面
        // product images
        {
          selector: {
            container: '[data-product-single-media-group]',
            item: ['[data-product-single-media-wrapper]']
          },
          section_name: 'product-images'
        },
        // color、size、style
        {
          selector: {
            container: '.t4s-swatch__list',
            item: ['[data-swatch-item]']
          },
          section_name: 'color-size-style'
        },
        // add to cart
        {
          selector: {
            container: '#main-product .t4s-product-form__submit',
            item: ['']
          },
          section_name: 'add-to-cart'
        },
        // type tabs
        {
          selector: {
            container: '.t4s-type-tabs',
            item: ['.t4s-tab-wrapper']
          },
          section_name: 'type-tabs'
        },
        // size-chart
        {
          selector: {
            container: '.t4s-btn__size-chart',
            item: ['']
          },
          section_name: 'size-chart'
        },
        // what's my size
        {
          selector: {
            container: '#what-my-size-entry',
            item: ['']
          },
          section_name: 'what-my-size'
        },
        // guide_table
        {
          selector: {
            container: '.guide_table',
            item: ['.header span']
          },
          section_name: 'guide-table'
        },
        // mibao_product_descrition_images
        {
          selector: {
            container: '.mibao_product_descrition_images',
            item: ['']
          },
          section_name: 'mibao-product-descrition-images'
        },
        // write a review
        {
          selector: {
            container: '.jdgm-write-rev-link',
            item: ['']
          },
          section_name: 'write-review'
        },
        // jude me - see more
        {
          selector: {
            container: '.jdgm-gallery__thumbnail-link',
            item: ['']
          },
          section_name: 'jude-me-see-more'
        },
        // menu icon - mobile
        {
          selector: {
            container: '[data-menu-drawer]',
            item: ['']
          },
          section_name: 'menu-icon-mobile'
        },
        // search icon - mobile
        {
          selector: {
            container: "[data-drawer-options][href='/search']",
            item: ['']
          },
          section_name: 'search-icon-mobile'
        },
        // account icon - mobile
        {
          selector: {
            container: '.member-center',
            item: ['']
          },
          section_name: 'account-icon-mobile'
        },
        // cart icon - mobile
        {
          selector: {
            container: '.t4s-site-nav__cart',
            item: ['']
          },
          section_name: 'cart-icon-mobile'
        },
        // view all
        {
          selector: {
            container: '.t4s-viewall-btn',
            item: ['']
          },
          section_name: 'view-all'
        },
        // slideshow
        {
          selector: {
            container: '[class*="__slideshow_"]',
            item: ['.flickityt4s-viewport']
          },
          section_name: 'slideshow'
        },
        // new filter
        {
          selector: {
            container: '.product-categories',
            item: ['.category-item']
          },
          section_name: 'new-filter'
        },
        // mini cart - checkout
        {
          selector: {
            container: "[name='checkout'].t4s-btn__checkout",
            item: ['']
          },
          section_name: 'mini-cart-checkout'
        },
        // mini cart - quantity
        {
          selector: {
            container: '.t4s-mini_cart__info .t4s-quantity-cart-item',
            item: ['button']
          },
          section_name: 'mini-cart-quantity'
        },
        // mini cart - edit/remove
        {
          selector: {
            container: '.t4s-mini_cart__info .actions-box',
            item: ['a']
          },
          section_name: 'mini-cart-edit-or-remove'
        },
        // menus - mobile
        {
          selector: {
            container: '#menu-mb__ul',
            item: ['> li']
          },
          section_name: 'menus-mobile'
        },
        // firework-video
        {
          selector: {
            container: '#video-ab',
            item: ['']
          },
          section_name: 'firework-video'
        },
        // custom section
        {
          selector: {
            container: '[class*="__custom_section_"]',
            item: ['video', 'a', '.button', 'button', 'img']
          },
          section_name: 'custom-section'
        },
        // hero vedio
        {
          selector: {
            container: '.t4s-hero-video',
            item: ['video', 'a', '.button', 'button', 'img']
          },
          section_name: 'hero-video'
        },
        // logo-list
        {
          selector: {
            container: '[class*="__logo_list_"]',
            item: ['.t4s-logo-item']
          },
          section_name: 'logo-list'
        },
        // product card
        {
          selector: {
            container: '[class*="__product_card_"]',
            item: ['a', '.button', 'img']
          },
          section_name: 'product-card'
        },
        // FAQ Section
        {
          selector: {
            container: '[class*="__faq_"]',
            item: ['.t4s-faq-question']
          },
          section_name: 'faq-section'
        }
      ];

      // 为所有内置配置添加 configType: "batch"
      trackingConfig.forEach((config) => {
        config.configType = 'batch';
        config.trackingPriority = 10;
        config.trackingSource = 'default';
      });

      let _pendingTrackingData = []; // 待处理的数据，初始时等于全部数据
      let debounceTimer = null; // 防抖定时器
      let autoMarksDebounceTimer = null; // autoMarks 防抖定时器
      const mutationTargetCountMap = new WeakMap(); // 跟踪发生变更的父元素次数
      const MAX_MUTATION_COUNT = 25; // 同一元素最多触发变更的次数
      const processedElements = new WeakSet(); // 跟踪已处理的元素
      const processedElementMeta = new WeakMap(); // 跟踪已处理元素的配置来源和优先级
      const pendingMutationTargets = new Set(); // 收集待处理的变更元素（用于防抖累加计数）
      const pendingAutoMarkRoots = new Set(); // 收集需要局部重新标记的根节点
      let impressObserver = null; // 曝光观察器
      const AUTO_TRACKING_BRIDGE_NAME = '__OGL_AUTO_TRACKING__';
      const elementIdIndex = new Map(); // element_id -> Set<HTMLElement>
      const registrySubscribers = new Set();
      let registryNotifyTimer = null;
      let resolveReadyPromise = null;
      const readyPromise = new Promise((resolve) => {
        resolveReadyPromise = resolve;
      });

      function getLiveElementsFromSet(elements) {
        return Array.from(elements || []).filter((element) =>
          document.documentElement.contains(element)
        );
      }

      function notifyRegistrySubscribers(reason) {
        if (registryNotifyTimer) return;

        registryNotifyTimer = setTimeout(() => {
          registryNotifyTimer = null;
          registrySubscribers.forEach((callback) => {
            try {
              callback({ reason });
            } catch (error) {
              console.error('auto-tracking registry subscriber error:', error);
            }
          });
        }, 0);
      }

      function registerTrackedElement(element) {
        if (!element || !element.getAttribute) return;

        const elementId = element.getAttribute('data-element-id');
        if (!elementId) return;

        const currentElements = elementIdIndex.get(elementId) || new Set();
        currentElements.add(element);
        elementIdIndex.set(elementId, currentElements);
        notifyRegistrySubscribers('element-registered');
      }

      function unregisterTrackedElement(element) {
        if (!element || !element.getAttribute) return;

        const elementId = element.getAttribute('data-element-id');
        processedElements.delete(element);
        processedElementMeta.delete(element);
        if (!elementId) return;

        const currentElements = elementIdIndex.get(elementId);
        if (!currentElements) return;

        currentElements.delete(element);
        if (currentElements.size === 0) {
          elementIdIndex.delete(elementId);
        }
        notifyRegistrySubscribers('element-unregistered');
      }

      const TRACKING_ATTRIBUTE_NAMES = [
        'data-tracking-id',
        'data-element-id',
        'data-element-selector',
        'data-config-type',
        'data-track-click',
        'data-track-impress',
        'data-impress-sent',
        'data-tracking-priority',
        'data-tracking-source'
      ];

      function getElementTrackingMeta(element) {
        const currentMeta = processedElementMeta.get(element) || {};
        const priorityFromAttr = Number(
          element.getAttribute('data-tracking-priority')
        );

        return {
          elementId:
            currentMeta.elementId || element.getAttribute('data-element-id'),
          trackingPriority:
            currentMeta.trackingPriority ||
            (Number.isFinite(priorityFromAttr) ? priorityFromAttr : 0),
          trackingSource:
            currentMeta.trackingSource ||
            element.getAttribute('data-tracking-source') ||
            ''
        };
      }

      function canOverrideTrackingElement(element, incomingMeta) {
        const currentMeta = getElementTrackingMeta(element);

        if (!currentMeta.elementId) {
          return true;
        }

        if (currentMeta.trackingPriority !== incomingMeta.trackingPriority) {
          return currentMeta.trackingPriority < incomingMeta.trackingPriority;
        }

        return false;
      }

      function clearTrackingElement(element) {
        unregisterTrackedElement(element);
        if (impressObserver) {
          impressObserver.unobserve(element);
        }
        TRACKING_ATTRIBUTE_NAMES.forEach((attrName) => {
          element.removeAttribute(attrName);
        });
        element.classList.remove('tracking-setup-tracking-highlight');
      }

      function clearOverriddenDescendants(rootElement, incomingMeta) {
        rootElement.querySelectorAll('[data-element-id]').forEach((child) => {
          if (canOverrideTrackingElement(child, incomingMeta)) {
            clearTrackingElement(child);
          }
        });
      }

      function getClosestTrackingElementByPriority(element) {
        let currentElement =
          element && element.nodeType === Node.ELEMENT_NODE
            ? element
            : element?.parentElement || element?.parentNode;
        let matchedElement = null;
        let matchedPriority = -1;

        while (
          currentElement &&
          currentElement !== document &&
          currentElement.nodeType === Node.ELEMENT_NODE
        ) {
          if (currentElement.hasAttribute('data-element-id')) {
            const { trackingPriority } = getElementTrackingMeta(currentElement);
            if (trackingPriority > matchedPriority) {
              matchedElement = currentElement;
              matchedPriority = trackingPriority;
            }
          }
          currentElement = currentElement.parentElement;
        }

        return matchedElement;
      }

      function unregisterTrackedSubtree(node) {
        if (!node || node.nodeType !== Node.ELEMENT_NODE) return;

        const element = node;
        unregisterTrackedElement(element);
        element
          .querySelectorAll('[data-element-id]')
          .forEach((child) => unregisterTrackedElement(child));
      }

      function markAutoTrackingReady() {
        const bridge = window[AUTO_TRACKING_BRIDGE_NAME];
        if (bridge) {
          bridge.ready = true;
        }
        document.body.setAttribute('data-tracking-ready', 'true');
        if (resolveReadyPromise) {
          resolveReadyPromise();
          resolveReadyPromise = null;
        }
        notifyRegistrySubscribers('ready');
      }

      function shouldIgnoreAutoTrackingNode(node) {
        if (!node || node.nodeType !== Node.ELEMENT_NODE) return true;

        const element = node;
        return Boolean(
          element.closest?.('[data-ogl-ignore-auto-tracking]') ||
          element.hasAttribute?.('data-ogl-ignore-auto-tracking') ||
          element.classList?.contains('rate-label') ||
          element.classList?.contains('rate-label-container') ||
          element.classList?.contains('stats-tooltip') ||
          element.classList?.contains('heatmap-canvas-overlay') ||
          element.classList?.contains('heatmap-hover-canvas-overlay') ||
          element.classList?.contains('heatmap-viewport-loading-overlay')
        );
      }

      function collectAutoMarkRoot(node) {
        if (!node || node.nodeType !== Node.ELEMENT_NODE) return;
        if (shouldIgnoreAutoTrackingNode(node)) return;

        for (const pendingRoot of pendingAutoMarkRoots) {
          if (pendingRoot === node || pendingRoot.contains(node)) {
            return;
          }
        }

        Array.from(pendingAutoMarkRoots).forEach((pendingRoot) => {
          if (node.contains(pendingRoot)) {
            pendingAutoMarkRoots.delete(pendingRoot);
          }
        });

        pendingAutoMarkRoots.add(node);
      }

      function markTrackingElement($element, options) {
        const element = $element && $element[0];
        if (!element) return false;

        const {
          trackingId,
          elementId,
          elementSelector,
          actionType = ['click'],
          configType,
          trackingPriority = 10,
          trackingSource = 'default'
        } = options;

        const incomingMeta = {
          elementId,
          trackingPriority,
          trackingSource
        };
        const currentMeta = getElementTrackingMeta(element);
        if (!canOverrideTrackingElement(element, incomingMeta)) {
          return false;
        }

        if (currentMeta.elementId) {
          clearTrackingElement(element);
        }
        clearOverriddenDescendants(element, incomingMeta);

        $element.attr('data-tracking-id', trackingId);
        $element.attr('data-element-id', elementId);
        $element.attr('data-element-selector', elementSelector);
        $element.attr('data-tracking-priority', String(trackingPriority));
        $element.attr('data-tracking-source', trackingSource);
        $element.addClass('tracking-setup-tracking-highlight');

        if (configType) {
          $element.attr('data-config-type', configType);
        } else {
          $element.removeAttr('data-config-type');
        }

        if (actionType.includes('click')) {
          $element.attr('data-track-click', 'true');
        } else {
          $element.removeAttr('data-track-click');
        }
        if (actionType.includes('impress')) {
          $element.attr('data-track-impress', 'true');
          if (currentMeta?.elementId && currentMeta.elementId !== elementId) {
            $element.removeAttr('data-impress-sent');
          }
        } else {
          $element.removeAttr('data-track-impress');
          $element.removeAttr('data-impress-sent');
        }

        processedElements.add(element);
        processedElementMeta.set(element, {
          elementId,
          trackingPriority,
          trackingSource
        });
        registerTrackedElement(element);
        observeImpress(element);

        return true;
      }

      function isConfigInCurrentScope(scope) {
        return !scope
          ? true
          : /\/\*$/.test(scope || '')
            ? pathname.startsWith(scope?.replace('/*', '') || '/')
            : pathname === scope;
      }

      function addContainerCandidate(candidates, element) {
        if (!element || candidates.indexOf(element) !== -1) return;
        candidates.push(element);
      }

      function findContainersInRoots(scopedRoots, containerSelector) {
        const containers = [];
        const jquery = window.$;

        scopedRoots.forEach((root) => {
          const $root = jquery(root);

          try {
            if ($root.is(containerSelector)) {
              addContainerCandidate(containers, root);
            }
          } catch (error) {
            console.error('局部 container selector 匹配失败:', error);
          }

          try {
            $root.find(containerSelector).each(function () {
              addContainerCandidate(containers, this);
            });
          } catch (error) {
            console.error('局部 container selector 查询失败:', error);
          }
        });

        return jquery(containers);
      }

      window[AUTO_TRACKING_BRIDGE_NAME] = {
        version: '1.0.0',
        ready: false,
        readyPromise,
        getElementsByElementId(elementId) {
          if (!elementId) return [];

          const currentElements = elementIdIndex.get(String(elementId));
          const liveElements = getLiveElementsFromSet(currentElements);
          if (currentElements && liveElements.length !== currentElements.size) {
            elementIdIndex.set(String(elementId), new Set(liveElements));
          }
          return liveElements;
        },
        getAllTrackedElements() {
          const trackedElements = [];
          elementIdIndex.forEach((elements) => {
            trackedElements.push(...getLiveElementsFromSet(elements));
          });
          return trackedElements;
        },
        subscribe(callback) {
          if (typeof callback !== 'function') {
            return function noop() { };
          }

          registrySubscribers.add(callback);
          return function unsubscribe() {
            registrySubscribers.delete(callback);
          };
        }
      };

      const domain = 'https://aws-mall.ogl-dragon.com';
      // const domain = "https://aws-mall-test.ogl-dragon.com";

      const platform = window.innerWidth > 768 ? 'pc' : 'mobile';
      const pathname = window.location.pathname;

      // 构造查询参数（将对象转换为 URLSearchParams）
      const queryParams = new URLSearchParams({
        current_page: 1,
        page_size: 10000,
        platform,
        pathname
      });

      function generateElementId({ baseId, element }) {
        const rawTagName =
          (element &&
            typeof element.prop === 'function' &&
            element.prop('tagName')) ||
          element?.tagName ||
          '';
        const tagName = rawTagName.toLowerCase();

        const normalizedBaseId = baseId || '';
        return tagName ? `${normalizedBaseId}_${tagName}` : normalizedBaseId;
      }

      function getT() {
        return fetch(`${domain}/api/v1/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            user_name: 'buried_point',
            user_password: 'CQmw852Vzw62zhwHwYaX'
          })
        })
          .then((res) => res.json())
          .then((res) => res.data.token)
          .catch((error) => {
            console.error('error:', error);
          });
      }

      // 初始化曝光观察器
      function initImpressObserver() {
        if (!impressObserver) {
          impressObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  const element = entry.target;
                  // 检查是否已经曝光过
                  if (element.dataset.impressSent) return;

                  const elementId = element.dataset.elementId;
                  if (elementId) {
                    // 发布曝光事件
                    Shopify.analytics.publish('auto_tracking', {
                      type: 'impress',
                      element_id: elementId,
                      platform,
                      customerId: window.customer_id || '',
                      pathname,
                      text: element.innerText?.slice(0, 100) || ''
                    });
                    // 标记已曝光
                    element.dataset.impressSent = 'true';
                    // 取消观察
                    impressObserver.unobserve(element);
                    console.log(`[曝光统计] element_id: ${elementId}`);
                  }
                }
              });
            },
            { threshold: 0.5 }
          ); // 50% 可见时触发
          console.log('曝光观察器已初始化');
        }
      }

      // 将元素添加到曝光观察器
      function observeImpress(element) {
        if (element && element.dataset.trackImpress && impressObserver) {
          impressObserver.observe(element);
        }
      }

      // 给元素添加标识并返回处理失败的数据（individual 模式）
      function addMarks(trackingData) {
        if (!trackingData || !trackingData.length || !window.$) return [];

        const filteredData = trackingData.filter((item) =>
          isConfigInCurrentScope(item.scope)
        );

        const successfullyProcessed = [];
        const failedToProcess = [];

        // 遍历数据，查找并添加标识
        filteredData.forEach((item) => {
          try {
            // 跳过 selector 为空或无效的数据
            if (!item.selector || item.selector.trim() === '') {
              console.warn('跳过 selector 为空的数据:', item);
              return;
            }

            // 跳过 batch 类型的数据（应该由 autoMarks 处理）
            if (item.params) {
              try {
                const params = JSON.parse(item.params);
                if (params.configType === 'batch') {
                  console.log(
                    '跳过 batch 类型数据，应由 autoMarks 处理:',
                    item
                  );
                  return;
                }
              } catch (e) {
                // JSON 解析失败，继续处理
              }
            }

            let foundElements = [];

            // 直接使用 jQuery
            try {
              const jqueryResult = $(item.selector);
              foundElements = Array.from(jqueryResult);
            } catch (jqueryError) {
              console.error('jQuery查询失败:', item.selector, jqueryError);
              foundElements = [];
            }

            if (foundElements.length === 0) {
              // 没找到元素，记录为处理失败
              failedToProcess.push(item);
              return;
            }

            // 解析 actionType（individual 模式默认为 click）
            let actionType = ['click'];
            if (item.params) {
              try {
                const params = JSON.parse(item.params);
                if (params.actionType && Array.isArray(params.actionType)) {
                  actionType = params.actionType;
                }
              } catch (e) {
                // JSON 解析失败，使用默认值
              }
            }

            // 为找到的元素添加数据属性，便于识别
            foundElements.forEach((el) => {
              markTrackingElement($(el), {
                trackingId: item.id || '',
                elementId: item.element_id || '',
                elementSelector: item.selector || '',
                actionType,
                trackingPriority: 30,
                trackingSource: 'server-individual'
              });
            });

            // 记录为成功处理
            successfullyProcessed.push(item);
          } catch (error) {
            console.error('给元素添加标识时出错:', item.selector, error);
            failedToProcess.push(item);
          }
        });

        console.log(
          `addMarks 结果: 成功 ${successfullyProcessed.length} 条, 失败 ${failedToProcess.length} 条`
        );

        // 返回处理失败的数据，这些数据需要在下次重新尝试处理
        return failedToProcess;
      }

      // 渲染服务端的埋点配置
      function renderServerTrackingConfig() {
        // 发起 fetch 请求
        getT().then(function (T) {
          // 如果当前页面处在 iframe 中，无需初始化埋点标识
          if (window !== window.top) return;

          // 添加请求头
          const headers = new Headers();
          headers.append('token', T);

          fetch(
            `${domain}/api/v1/buried-point/list-paging?${queryParams.toString()}&site_id=${window.ogl_config.site?.id
            }`,
            {
              method: 'GET',
              headers: headers
            }
          )
            .then((response) => {
              return response.json(); // 解析 JSON 响应
            })
            .then((data) => {
              const trackingData = data?.data?.total_list || [];
              console.log(`获取到 ${trackingData.length} 条埋点数据`);

              // 分离 individual 和 batch 模式的数据
              const individualData = [];
              const batchConfigs = [];

              trackingData.forEach((item) => {
                if (item.params) {
                  try {
                    const params = JSON.parse(item.params);
                    // batch 模式必须有 container 和 item
                    if (
                      params.configType === 'batch' &&
                      params.container &&
                      params.item
                    ) {
                      // batch 模式，转换为配置格式
                      // 从 params 中提取 section_name，如果没有则使用 item.element_id 作为备用
                      batchConfigs.push({
                        section_name:
                          params.section_name ||
                          item.element_id ||
                          `batch-${item.id}`,
                        selector: {
                          container: params.container,
                          item: params.item
                        },
                        actionType: params.actionType || ['click'],
                        scope: item.scope,
                        configType: 'batch',
                        trackingPriority: 20,
                        trackingSource: 'server-batch'
                      });
                    } else {
                      // individual 模式
                      individualData.push(item);
                    }
                  } catch (e) {
                    // JSON 解析失败，按 individual 模式处理
                    individualData.push(item);
                  }
                } else {
                  // 没有 params，按 individual 模式处理
                  individualData.push(item);
                }
              });

              console.log(
                `individual 模式: ${individualData.length} 条, batch 模式: ${batchConfigs.length} 条`
              );

              // 处理 individual 模式数据
              _pendingTrackingData = [...individualData];
              const failedToProcess = addMarks(_pendingTrackingData);
              _pendingTrackingData = failedToProcess; // 更新为处理失败的数据

              // 处理 batch 模式配置
              if (batchConfigs.length > 0) {
                // 将 batch 配置添加到 trackingConfig，使用统一的处理逻辑
                batchConfigs.forEach((config) => {
                  trackingConfig.push(config);
                });
                // 重新执行 autoMarks 处理新增的配置
                autoMarks();
              }
            })
            .catch((error) => {
              console.error('请求失败:', error);
              // 在这里处理错误
            });
        });
      }

      // 防抖的 addMarks 函数
      function debouncedAddMarks(delay = 1000) {
        if (debounceTimer) {
          clearTimeout(debounceTimer);
        }

        debounceTimer = setTimeout(() => {
          console.log(
            `防抖 addMarks 开始，待处理数据: ${_pendingTrackingData.length} 条`
          );
          const failedToProcess = addMarks(_pendingTrackingData);
          _pendingTrackingData = failedToProcess; // 更新为处理失败的数据
          console.log(
            `防抖 addMarks 完成，剩余待处理数据: ${_pendingTrackingData.length} 条`
          );
        }, delay);
      }

      function autoMarks(targetRoots) {
        if (!window.$) {
          console.warn('jQuery 未加载，无法执行 autoMarks');
          return;
        }

        const scopedRoots = Array.isArray(targetRoots)
          ? targetRoots.filter(
            (root) => root && root.nodeType === Node.ELEMENT_NODE
          )
          : [];
        const isLocalScan = scopedRoots.length > 0;

        trackingConfig.forEach((config, configIndex) => {
          try {
            const {
              selector,
              section_name,
              actionType = ['click'],
              configType,
              scope,
              trackingPriority = 10,
              trackingSource = 'default'
            } = config;

            if (!selector || !selector.container) {
              // console.warn(`配置 ${configIndex} 缺少必要的 selector.container`);
              return;
            }

            if (!isConfigInCurrentScope(scope)) {
              return;
            }

            // 确保 container 选择器包含 :visible
            let containerSelector = selector.container;
            if (!containerSelector.includes(':visible')) {
              // 如果没有 :visible，添加到选择器末尾（在任何 :eq() 之前）
              containerSelector = containerSelector.replace(
                /(:eq\(\d+\).*)?$/,
                ':visible$1'
              );
            }

            const $containers = isLocalScan
              ? findContainersInRoots(scopedRoots, containerSelector)
              : $(containerSelector);

            if ($containers.length === 0) {
              return;
            }

            // 使用配置中的 section_name，如果没有则使用 'unknown'
            const sectionName = section_name || 'unknown';
            // 统一使用 auto-config-{configIndex} 作为 tracking-id
            const trackingId = `auto-config-${configIndex}`;

            $containers.each(function (containerIndex) {
              const $container = $(this);

              // 处理 item 数组
              if (!selector.item || !Array.isArray(selector.item)) {
                // console.warn(`配置 ${configIndex}: selector.item 必须是数组`);
                return;
              }

              // 如果 item 是空数组或只有空字符串，直接给容器添加标识
              if (selector.item.length === 0 || selector.item[0] === '') {
                const autoGeneratedElementId = `eq${containerIndex}_${sectionName}_container`;
                const generatedElementId = generateElementId({
                  baseId: autoGeneratedElementId,
                  element: $container
                });

                // 构建完整的 selector（包含 :visible 和 :eq()）
                const fullSelector = `${containerSelector}:eq(${containerIndex})`;

                markTrackingElement($container, {
                  trackingId,
                  elementId: generatedElementId,
                  elementSelector: fullSelector,
                  actionType,
                  configType,
                  trackingPriority,
                  trackingSource
                });
              } else {
                // 遍历 item 选择器数组
                selector.item.forEach((itemSelector) => {
                  if (!itemSelector) return;

                  // 在容器内查找 item 元素
                  const $items = $container.find(itemSelector);

                  if ($items.length === 0) {
                    return;
                  }

                  $items.each(function (itemIndex) {
                    const $item = $(this);

                    // 生成 element_id: eq{containerIndex}_{section_name}_{itemIndex}
                    const autoGeneratedElementId = `eq${containerIndex}_${sectionName}_${itemIndex}`;
                    const generatedElementId = generateElementId({
                      baseId: autoGeneratedElementId,
                      element: $item
                    });

                    // 构建完整的 selector（container:visible:eq(n) + item:visible:eq(n)）
                    const fullSelector = `${containerSelector}:eq(${containerIndex}) ${itemSelector}:visible:eq(${itemIndex})`;

                    markTrackingElement($item, {
                      trackingId,
                      elementId: generatedElementId,
                      elementSelector: fullSelector,
                      actionType,
                      configType,
                      trackingPriority,
                      trackingSource
                    });
                  });
                });
              }
            });
          } catch (error) {
            console.error(`配置 ${configIndex} 处理失败:`, error);
          }
        });

        console.log(
          scopedRoots.length > 0
            ? `autoMarks 局部执行完成，roots: ${scopedRoots.length}`
            : 'autoMarks 执行完成'
        );
      }

      // 防抖的 autoMarks 函数
      function debouncedAutoMarks(delay = 1000) {
        if (autoMarksDebounceTimer) {
          clearTimeout(autoMarksDebounceTimer);
        }

        autoMarksDebounceTimer = setTimeout(() => {
          console.log('检测到DOM变化，重新执行 autoMarks');
          const autoMarkRoots = Array.from(pendingAutoMarkRoots);

          // 在真正执行 autoMarks 时才累加计数，避免短时间内多次 mutation 导致计数过快增长
          pendingMutationTargets.forEach((target) => {
            const currentCount = mutationTargetCountMap.get(target) || 0;
            mutationTargetCountMap.set(target, currentCount + 1);
          });
          pendingMutationTargets.clear(); // 清空待处理集合
          pendingAutoMarkRoots.clear();

          autoMarks(autoMarkRoots.length > 0 ? autoMarkRoots : undefined);
        }, delay);
      }

      // 添加 body 内容变化监听器
      const observer = new MutationObserver((mutations) => {
        let shouldRunAutoMarks = false;

        mutations.forEach((mutation) => {
          if (shouldIgnoreAutoTrackingNode(mutation.target)) {
            return;
          }

          const isAddedNodes =
            mutation.type === 'childList' && mutation.addedNodes.length > 0;
          const isRemovedNodes =
            mutation.type === 'childList' && mutation.removedNodes.length > 0;
          const isAriaHidden =
            mutation.type === 'attributes' &&
            mutation.attributeName === 'aria-hidden' &&
            mutation.target.getAttribute('aria-hidden') === 'false';
          const isDisplayBlock =
            mutation.type === 'attributes' &&
            mutation.attributeName === 'style' &&
            mutation.target.style.display === 'block';

          if (isAriaHidden || isDisplayBlock) {
            // target 不包含 rate-label 这个类名才执行
            if (!shouldIgnoreAutoTrackingNode(mutation.target)) {
              console.log(
                '===> rate-label, so not run autoMarks',
                mutation.target
              );
              collectAutoMarkRoot(mutation.target);
              debouncedAutoMarks(400);
            }
            return;
          }

          if (isRemovedNodes) {
            mutation.removedNodes.forEach((node) => {
              unregisterTrackedSubtree(node);
            });
          }

          // 只检查是否有节点添加，或者 aria-hidden 属性变为 false
          if (isAddedNodes) {
            const target = mutation.target;
            const hasTrackableAddedNode = Array.from(mutation.addedNodes).some(
              (node) =>
                node.nodeType === Node.ELEMENT_NODE &&
                !shouldIgnoreAutoTrackingNode(node)
            );

            if (!hasTrackableAddedNode) {
              return;
            }

            // 获取该元素的变更次数
            const currentCount = mutationTargetCountMap.get(target) || 0;

            // 如果未超过最大次数，收集到待处理集合（不立即累加计数）
            if (
              currentCount < MAX_MUTATION_COUNT &&
              !shouldIgnoreAutoTrackingNode(target)
            ) {
              pendingMutationTargets.add(target); // 只收集，不累加计数
              mutation.addedNodes.forEach((node) => {
                if (
                  node.nodeType === Node.ELEMENT_NODE &&
                  !shouldIgnoreAutoTrackingNode(node)
                ) {
                  collectAutoMarkRoot(node);
                }
              });
              shouldRunAutoMarks = true;
            } else {
              // 已超过最大次数，忽略此元素的变更
              // console.log('===> 元素变更次数已达上限，跳过:', target);
            }
          }
        });

        if (shouldRunAutoMarks) {
          console.log('===> addElement, so run autoMarks');
          // 重新执行 autoMarks 以标记动态添加的元素
          debouncedAutoMarks(400);

          // 如果有待处理的后端数据，也重新处理
          if (_pendingTrackingData.length > 0) {
            debouncedAddMarks(300);
          }
        }
      });

      // 开始观察 body 的变化 - 只监听子节点添加和特定属性变化
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden', 'style'] // 只监听需要的属性，提升性能
      });

      // 给元素添加事件绑定，找到距离目标元素最近的父级元素
      document.addEventListener(
        'click',
        function (event) {
          // 首先判断是否为真实的用户点击事件
          if (!event.isTrusted) {
            console.log('非用户真实点击，忽略此事件');
            return;
          }

          // 1. 获取当前点击的元素
          const currentElement = event.target;
          const trackingElement =
            getClosestTrackingElementByPriority(currentElement);

          // 检查是否需要统计点击
          if (!trackingElement || !trackingElement.dataset.trackClick) {
            return;
          }

          const text = trackingElement?.innerText?.slice(0, 100) || '';
          const elementId = trackingElement?.dataset.elementId;

          // 2. 发送埋点
          if (elementId) {
            Shopify.analytics.publish('auto_tracking', {
              type: 'click',
              element_id: elementId,
              platform,
              customerId: window.customer_id || '',
              pathname,
              text
            });
          }
        },
        true
      );

      // 初始化内置埋点配置
      if (document.readyState === 'loading') {
        // DOM 还在加载中，等待 DOMContentLoaded
        document.addEventListener('DOMContentLoaded', function () {
          initImpressObserver(); // 初始化曝光观察器
          autoMarks();
          renderServerTrackingConfig();

          // 设置埋点已准备好
          markAutoTrackingReady();
        });
      } else {
        // DOM 已经加载完成，直接执行
        initImpressObserver(); // 初始化曝光观察器
        autoMarks();
        renderServerTrackingConfig();
        // 设置埋点已准备好
        markAutoTrackingReady();
      }

      // ========== 停留时间和浏览深度统计 ==========
      let pageEnterTime = Date.now(); // 记录页面进入时间
      let maxScrollDepth = 1; // 记录最大浏览深度（屏数），默认为1
      let scrollDepthDebounceTimer = null; // 滚动防抖定时器
      let statisticsSent = false; // 防止重复发送统计数据

      // 计算当前浏览深度（屏数），使用 Math.floor 向下取整
      function calculateScrollDepth() {
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        const viewportHeight = window.innerHeight;
        // scrollTop=0时，depth=0，返回1（第一屏）
        // scrollTop>=viewportHeight时，depth>=1，返回2（第二屏）
        const depth = Math.floor(scrollTop / viewportHeight);
        return depth + 1;
      }

      // 防抖的滚动事件处理
      function debouncedScrollHandler() {
        if (scrollDepthDebounceTimer) {
          clearTimeout(scrollDepthDebounceTimer);
        }

        scrollDepthDebounceTimer = setTimeout(() => {
          const currentDepth = calculateScrollDepth();

          // 如果浏览深度增加，更新最大浏览深度
          if (currentDepth > maxScrollDepth) {
            maxScrollDepth = currentDepth;
            console.log(`[浏览深度更新] 当前深度: ${maxScrollDepth} 屏`);
          }
        }, 100); // 100ms 防抖
      }

      // 监听滚动事件，统计浏览深度
      window.addEventListener('scroll', debouncedScrollHandler, {
        passive: true
      });

      // 页面离开时发送停留时间和浏览深度统计
      function sendPageStatistics() {
        // 防止重复发送
        if (statisticsSent) {
          console.log(`[页面统计] 已发送过，跳过重复发送`);
          return;
        }
        statisticsSent = true;

        const pageLeaveTime = Date.now();
        const duration = pageLeaveTime - pageEnterTime; // 停留时间（毫秒）

        console.log(
          `[页面统计] 停留时间: ${duration}ms, 浏览深度: ${maxScrollDepth}屏`
        );

        // 如果停留时间大于1天，只记录为1天的毫秒数
        const ONE_DAY_MS = 24 * 60 * 60 * 1000;
        const reportedDuration = duration > ONE_DAY_MS ? ONE_DAY_MS : duration;

        Shopify.analytics.publish('auto_tracking', {
          type: 'page_statistics',
          platform,
          customerId: window.customer_id || '',
          pathname,
          duration: reportedDuration, // 停留时间（毫秒）
          scroll_depth: maxScrollDepth // 浏览深度（屏数）
        });
      }

      // 监听页面离开事件
      // 使用 visibilitychange 处理页面切换和标签页隐藏
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
          sendPageStatistics();
        }
      });

      // 使用 pagehide 处理页面卸载（包括关闭、刷新、导航等）
      window.addEventListener('pagehide', function () {
        sendPageStatistics();
      });

      console.log('[页面统计] 停留时间和浏览深度统计已启用');
      // ========== 停留时间和浏览深度统计结束 ==========
    } catch (error) {
      console.error('>>> auto checking error:', error);
    }
  })();

  // 商品详情页特殊上报逻辑整合
  (function () {
    if (!document.body.classList.contains('template-product')) {
      return
    }
    function trackVideoPlayStart(product) {
      var video = document.getElementById('size_guide_video-player');
      const product_type = product.type || '';
      const video_map = window.size_guide_video_map || {};
      video.src = video_map[product_type]?.video || '';
      var timeupdateTracked = false;
      var playTracked = false;
      if (video) {
        video.addEventListener('play', function () {
          if (playTracked) return;
          Shopify.analytics.publish('auto_tracking', {
            type: 'video-play-start'
          });
          playTracked = true;
        });
        video.addEventListener('timeupdate', function () {
          if (!timeupdateTracked && this.currentTime >= 3) {
            Shopify.analytics.publish('auto_tracking', {
              type: 'video-play-3s'
            });
            timeupdateTracked = true;
          }
        });
        video.addEventListener('ended', function () {
          Shopify.analytics.publish('auto_tracking', {
            type: 'video-play-complete'
          });
        });
      }
    }

    function trackVideoIntersection() {
      // 2. 获取所有需要监听的元素
      const mediaItems = document.querySelectorAll('.t4s-product__media-item');

      // 3. 配置 IntersectionObserver 的参数 (可选)
      // const options = {
      //   root: null,       // 监听元素的祖先节点，null 表示默认使用浏览器视口 (viewport)
      //   rootMargin: '0px',// 视口的边距，可以用来提前或延迟触发 (例如 '50px' 表示提前 50px 触发)
      //   threshold: 0.5    // 触发的阈值，0.1 表示元素有 10% 进入视口时就会触发回调
      // };

      // let observedNum = 0

      // // 4. 创建观察者实例
      // const observer = new IntersectionObserver((entries, observer) => {
      //   entries.forEach(entry => {
      //     // isIntersecting 属性为 true 表示元素当前在视口中可见
      //     if (entry.isIntersecting) {
      //       console.log('test3 product_media', observedNum)
      //       const source = entry.target.querySelector('video source')?.src || entry.target.dataset.imgSrc || ""
      //       const index = entry.target.dataset.index || 0
      //       const type = entry.target.dataset.mediaType || ""
      //       if (observedNum == 2) {
      //         Shopify.analytics.publish("product_media", {
      //           type: "three_impressions",
      //           product_id: meta.product.id,
      //           media_index: index,
      //           media_name: source,
      //           media_type: type
      //         });
      //         observer.disconnect()
      //       }
      //       observedNum += 1
      //     } else {
      //       // 元素离开视口，不可见
      //       // console.log('元素已离开视口:', entry.target);
      //     }
      //   });
      // }, options);

      // 5. 遍历获取到的元素，并让观察者开始监听它们
      if (mediaItems.length > 0) {
        mediaItems.forEach((item) => {
          // observer.observe(item)
          item.addEventListener('click', function (e) {
            const source =
              e.currentTarget.querySelector('video source')?.src ||
              e.currentTarget.dataset.imgSrc ||
              '';
            const index = e.currentTarget.dataset.index || 0;
            const type = e.currentTarget.dataset.mediaType || '';
            Shopify.analytics.publish('product_media', {
              type: 'click',
              product_id: meta.product.id,
              media_index: index,
              media_name: source,
              media_type: type
            });
          });
        });
      } else {
        console.warn('未找到任何 .t4s-product__media-item 元素');
      }
    }

    function initTrackPdpClickEvent(e) {

      function sendPdpData(info) {
        const click_type = info.type

        Shopify.analytics.publish("product_interest_click", {
          type: click_type,
          text: info.text
        });
      }

      function review_click(e) {
        if (document.querySelector('#judgeme_product_reviews')?.contains(e.target)) {
          console.log('test4 trackPdpClickEvent judgeme')
          sendPdpData({
            type: 'click_prd_customer_review'
          })
        }
      }

      function pdp_ele_click(e) {
        const pdp_click_type = e.currentTarget.dataset.pdpClick
        const pdp_click_text = e.currentTarget.dataset.pdpClick_text

        sendPdpData({
          type: pdp_click_type,
          text: pdp_click_text
        })
      }

      document.addEventListener('click', review_click, true)

      // firework点击
      document.addEventListener('fw:embed-feed:thumbnail-click', function (event) {
        console.log('test4 fw click')
        sendPdpData({
          type: 'click_prd_product_egc'
        })
      });

      const pdp_click_eles = document.querySelectorAll('[data-pdp-click]')
      pdp_click_eles.forEach((ele) => {
        ele.addEventListener('click', pdp_ele_click, true)
      })
    }

    initTrackPdpClickEvent()

    document.addEventListener('DOMContentLoaded', function () {
      if (meta?.product) {
        trackVideoPlayStart(meta.product);
        trackVideoIntersection();
      }
    });

  })();
})();
